import type { QueueDraft } from './types';
import { isValidWeeklySlot } from './weeklySlots';

export type QueueDraftValidationCode =
  | 'name_required'
  | 'slots_required'
  | 'accounts_required'
  | 'invalid_slot'
  | 'gap_invalid';

export type QueueDraftValidationResult =
  | { ok: true }
  | { ok: false; code: QueueDraftValidationCode };

export function validateQueueDraft(draft: QueueDraft): QueueDraftValidationResult {
  if (draft.name.trim().length === 0) {
    return { ok: false, code: 'name_required' };
  }

  if (draft.weeklySlots.length === 0) {
    return { ok: false, code: 'slots_required' };
  }

  if (draft.socialConnectionIds.length === 0) {
    return { ok: false, code: 'accounts_required' };
  }

  if (draft.weeklySlots.some((slot) => !isValidWeeklySlot(slot))) {
    return { ok: false, code: 'invalid_slot' };
  }

  if (!Number.isInteger(draft.minGapMinutes) || draft.minGapMinutes < 5) {
    return { ok: false, code: 'gap_invalid' };
  }

  return { ok: true };
}
